import React, { useEffect, useState, useMemo } from "react";
import classnames from "classnames";
import { useGlobal } from "reactn";
import { Link } from "react-router-dom";
import { useSummonerMatch } from "api/summonerProfileApi";
import { usePatches } from "api/patchApi";
import BuildSection from "./BuildSection";
import PostGameContainer from "./PostGameContainer";
import ScoringSection from "./ScoringSection";
import Performance from "./Performance";
import Timeline from "./Timeline";
import Metrics from "./Metrics";
import { hasPerfScore } from "lib/general-helper";
import { INTERNAL_CURRENT_SEASON } from "@ugg/shared/constants/seasons";
import { MediaQuery } from "@outplayed/responsive";
// import MatchPage from "../ProfileMatchPage/MatchPage";

const ExpandedMatchCard = (props) => {
  const tabs = ["Post Game", "Build"];
  const [windowBreakpoint] = useGlobal("responsive");
  const { matchId, version, regionId, summonerName, winConditionClass } = props;
  const [chosenTab, setChosenTab] = useState(tabs[0]);
  const { data: patches, loading: loadingPatches } = usePatches();
  const { data, loading, error } = useSummonerMatch(regionId, summonerName, version, matchId.toString());
  if (!data || loading || error || loadingPatches) {
    return (
      <div className="expanded-match-card-container">
        <div className="loader">
          <div className="spinthatshit-loader">
            <div className="spinner" />
          </div>
        </div>
      </div>
    );
  }

  const shouldDisplayScoreSection = hasPerfScore(data.match.matchSummary.queueType);
  const fullMatchURL = `/lol/profile/${regionId}/${summonerName}/match/${version}/${matchId}`;
  const navToFullMatch = {
    pathname: fullMatchURL.toLowerCase(),
    state: {
      matchSummary: props.data,
    },
  };

  const currentPatch = patches.find((patch) => patch.id === version);
  const isMobile = ["MOBILE_LARGE", "MOBILE_MEDIUM", "MOBILE_SMALL"].includes(windowBreakpoint);
  const tabsArray = isMobile
    ? ["Post Game", "Performance", "Item Build"]
    : data?.match.matchSummary.queueType === "normal_aram"
    ? ["Post Game", "Performance", "Item Build", "Metrics"]
    : ["Post Game", "Performance", "Item Build", "Timeline", "Metrics"];
  const seasonId = currentPatch.season || INTERNAL_CURRENT_SEASON;
  // TODO: Remove completely eventually
  // if (shouldDisplayScoreSection) {
  //   tabsArray.push("Scoring")
  // }

  return (
    <div className="expanded-match-card-container">
      <div className="expanded-match-card_nav">
        <div className="tabs">
          {tabsArray.map((tab, index) => (
            <div
              key={index}
              className={classnames("nav-btn", { active: tab === chosenTab }, winConditionClass)}
              onClick={() => setChosenTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>
        {/*<Link to={navToFullMatch} className="full-match nav-btn" rel="noreferrer noopener">
          {(windowBreakpoint === "MOBILE_SMALL") ? "Full Match" : "See Full Match Details"}
        </Link>*/}
      </div>
      {chosenTab === "Item Build" ? (
        <BuildSection data={data} winConditionClass={winConditionClass} />
      ) : chosenTab === "Scoring" ? (
        <ScoringSection data={data} mainSummonerName={summonerName} winConditionClass={winConditionClass} />
      ) : chosenTab === "Timeline" ? (
        <Timeline data={data} />
      ) : chosenTab === "Performance" ? (
        <Performance data={data} />
      ) : chosenTab === "Metrics" ? (
        <Metrics data={data} />
      ) : (
        <PostGameContainer seasonId={seasonId} data={data && data.match} isBadPerfScore={props.isBadPerfScore} />
      )}
    </div>
  );
};

export default ExpandedMatchCard;
